import { ActivityLogTypeEnum } from "services/api/fleet/vehicles/activitylogs/types";
import { BadgeProps } from "ui/components/Badge/types";

// Vizualna konfiguracija po tipu aktivnosti (ikona + boja node-a + varijanta Badge-a).
export interface ActivityTypeConfig {
  icon: string;
  nodeBg: string; // pozadina obojenog kruga (node)
  badgeVariant: BadgeProps["variant"];
}

export const ACTIVITY_TYPE_CONFIG: Record<number, ActivityTypeConfig> = {
  [ActivityLogTypeEnum.Create]: {
    icon: "/media/icons/add.svg",
    nodeBg: "bg-emerald-500",
    badgeVariant: "success",
  },
  [ActivityLogTypeEnum.Update]: {
    icon: "/media/icons/edit.svg",
    nodeBg: "bg-sky-500",
    badgeVariant: "info",
  },
  [ActivityLogTypeEnum.Delete]: {
    icon: "/media/icons/trash.svg",
    nodeBg: "bg-rose-500",
    badgeVariant: "danger",
  },
  [ActivityLogTypeEnum.Import]: {
    icon: "/media/icons/data-import.svg",
    nodeBg: "bg-amber-500",
    badgeVariant: "warning",
  },
  [ActivityLogTypeEnum.Publish]: {
    icon: "/media/icons/external-link.svg",
    nodeBg: "bg-violet-500",
    badgeVariant: "violet",
  },
};

export const DEFAULT_ACTIVITY_TYPE_CONFIG: ActivityTypeConfig = {
  icon: "/media/icons/info.svg",
  nodeBg: "bg-slate-400",
  badgeVariant: "secondary",
};

export const getActivityTypeConfig = (type: number): ActivityTypeConfig =>
  ACTIVITY_TYPE_CONFIG[type] ?? DEFAULT_ACTIVITY_TYPE_CONFIG;

// Deterministicna boja avatara iz imena korisnika.
const AVATAR_COLORS = [
  "bg-sky-500", "bg-emerald-500", "bg-violet-500", "bg-amber-500",
  "bg-rose-500", "bg-teal-500", "bg-indigo-500", "bg-pink-500",
];

export const getAvatarColor = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

/** Hrvatska množina uz broj izmjena: 1 izmjena, 2-4 izmjene, 5+ izmjena. */
export const getChangeCountLabel = (count: number): string => {
  const lastTwo = count % 100;
  const last = count % 10;

  if (lastTwo >= 11 && lastTwo <= 14) return "izmjena";
  if (last === 1) return "izmjena";
  if (last >= 2 && last <= 4) return "izmjene";

  return "izmjena";
};

export const getInitials = (name: string): string =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("") || "?";
